// "You have N comments" banner dismissal memory — kept only in this browser
// (localStorage), per guide, keyed by guide_info_id (the id comment_count
// itself lives on). Stores the comment_count value AS OF the last dismiss,
// not a plain boolean, so the banner reappears once the count climbs past
// that again rather than staying dismissed forever. Same storage idiom as
// PlaceMenu.js's hasNoGoodPhoto/setNoGoodPhoto (src/CommonWeb/PlaceMenu.js).
const KEY = "andiamo_comment_dismiss_v1";

function readStore() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}") || {};
  } catch (e) {
    return {};
  }
}

function writeStore(store) {
  try {
    localStorage.setItem(KEY, JSON.stringify(store));
  } catch (e) {
    /* storage unavailable — the memory just isn't kept */
  }
}

const CommentDismiss = {
  getDismissedCount(guideInfoId) {
    if (guideInfoId == null) return 0;
    const n = readStore()[guideInfoId];
    return typeof n === "number" ? n : 0;
  },
  setDismissedCount(guideInfoId, count) {
    if (guideInfoId == null) return;
    const store = readStore();
    store[guideInfoId] = count;
    writeStore(store);
  },
};

export default CommentDismiss;
